export const getDigitsOnly = (phoneNumber) => {
  return (phoneNumber || "").replace(/\D/g, "");
};

export const formatPhoneNumberForInput = (phoneNumber) => {
  const digits = getDigitsOnly(phoneNumber);
  const limitedDigits = digits.slice(0, 10);

  if (limitedDigits.length <= 3) {
    return limitedDigits.length > 0
      ? `(${limitedDigits}`
      : limitedDigits;
  } else if (limitedDigits.length <= 6) {
    return `(${limitedDigits.slice(0, 3)}) ${limitedDigits.slice(3)}`;
  } else {
    return `(${limitedDigits.slice(0, 3)}) ${limitedDigits.slice(
      3,
      6,
    )}-${limitedDigits.slice(6)}`;
  }
};

export const formatPhoneNumberForDisplay = (phoneNumber) => {
  const cleaned = getDigitsOnly(phoneNumber);
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phoneNumber;
};

export const isValidPhoneNumber = (phoneNumber) => {
  const digits = getDigitsOnly(phoneNumber);
  return digits.length === 10;
};

export const canAcceptMoreDigits = (phoneNumber) => {
  const digits = getDigitsOnly(phoneNumber);
  return digits.length < 10;
};
